import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './Modal.module.css';

const Modal = ({ children }) => (
    <div className={classnames(css.root, 'w-100 h-100 position-fixed')}>
        <div className={classnames(css.content, 'position-relative')}>
            {children}
        </div>
    </div>
);

Modal.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Modal;
